import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sortedIds: [],
  entities: {},
  filters: {},
  sorter: {},
  isLoaded: false,
  isSavingActive: false,
  search: '',
  page: 1,
  pageCount: 1,
  selectedAd: null,
  sources: [],
  isSourcesLoaded: false,
  imagePreview: {
    icon: null,
    hero: null,
  },
}

const arcAdsSlice = createSlice({
  name: 'arcAds',
  initialState,
  reducers: {
    fetchArcAdsSuccess: (state, { payload }) => {
      // Normalize entities by ID
      const entities = {}
      payload.ads.forEach(ad => {
        entities[ad.id] = ad
      })
      return {
        ...state,
        isLoaded: true,
        page: payload.page,
        pageCount: payload.pageCount,
        entities,
        included: payload.included,
        sortedIds: payload.sortedIds,
      }
    },
    fetchArcAdsFailure: (state) => state,
    fetchArcAdDetailsSuccess: (state, { payload }) => ({
      ...state,
      selectedAd: payload.ad,
      included: payload.included || state.included || [],
    }),
    fetchArcAdDetailsFailure: (state) => ({
      ...state,
      selectedAd: null,
    }),
    fetchArcAdSourcesSuccess: (state, { payload }) => ({
      ...state,
      sources: payload.sources,
      isSourcesLoaded: true,
    }),
    fetchArcAdSourcesFailure: (state) => ({
      ...state,
      sources: [],
      isSourcesLoaded: false,
    }),
    saveFiltersAndSorter: (state, { payload = {} }) => ({
      ...state,
      search: payload.search,
      filters: payload.filters || initialState.filters,
      sorter: payload.sorter || initialState.sorter,
    }),
    startSaving: (state) => ({
      ...state,
      isSavingActive: true,
    }),
    finishSaving: (state) => ({
      ...state,
      isSavingActive: false,
    }),
    setImagePreview: (state, { payload }) => ({
      ...state,
      imagePreview: {
        ...state.imagePreview,
        [payload.type]: payload.url,
      },
    }),
    clearImagePreview: (state, { payload }) => ({
      ...state,
      imagePreview: {
        ...state.imagePreview,
        [payload.type]: null,
      },
    }),
    updateArcAdSuccess: (state, { payload }) => {
      if (payload.data && payload.data.id) {
        return {
          ...state,
          entities: {
            ...state.entities,
            [payload.data.id]: payload.data,
          },
        }
      }
      return state
    },
    updateArcAdFailure: (state) => state,
    clearData: () => initialState,
  },
})

export default arcAdsSlice